import { render, staticRenderFns } from "./larva_counts.vue?vue&type=template&id=1ff204e6&"
import script from "./larva_counts.vue?vue&type=script&lang=js&"
export * from "./larva_counts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports